import React from 'react';
import { Box, TableCell, TableRow } from '@mui/material';
import Loader from '../Loader/Loader';

const TableLoader = () => {
  return (
    <TableRow>
      <TableCell 
        colSpan={12} 
        align="center" 
        sx={{ height: '70vh' }}
      >
        <Box
          data-testid="loader-container"
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          <Loader size={25} />
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default TableLoader;
